/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIsValidImageUrl } from '../../utils';
import { EgressErrorMessage } from '../..';
export var maxWidths = {
  xsmall: '25%',
  small: '37.5%',
  medium: '50%',
  large: '75%',
  xlarge: '100%'
};
function ImageInner(_ref) {
  var forgeDoc = _ref.forgeDoc;
  var _ref2 = forgeDoc.props,
    src = _ref2.src,
    alt = _ref2.alt,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'xlarge' : _ref2$size;
  var maxWidth = maxWidths[size] || '100%';
  return jsx("img", {
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      display: 'block',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      margin: 'auto',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      maxWidth: maxWidth,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      textAlign: 'center'
    },
    src: src,
    alt: alt
  });
}
export var Image = function Image(props) {
  var _ref3 = props.forgeDoc.props,
    src = _ref3.src;
  var isValidUrl = useIsValidImageUrl(src);
  if (isValidUrl) {
    return jsx(ImageInner, props);
  }
  return jsx(EgressErrorMessage, {
    url: src
  });
};